import React from 'react';
import GenericNomenclatureList from './GenericNomenclatureList';
import { useFrequencyTypeMutations } from '../../../hooks/useNomenclatures';

const FrequencyTypeList = ({ items, onUpdate }) => {
  const mutations = useFrequencyTypeMutations();

  const fields = [
    { name: 'requiresSchedule', label: 'Requires Schedule', type: 'boolean' },
    { name: 'requiresTrigger', label: 'Requires Trigger', type: 'boolean' }
  ];

  return (
    <GenericNomenclatureList
      items={items}
      type="frequency-types"
      title="Frequency Types"
      fields={fields}
      mutations={mutations}
      onUpdate={onUpdate}
    />
  );
};

export default FrequencyTypeList;

